export enum DocumentAddStep {
  Start = 0,
  TakePhoto = 1,
  PreviewPhoto = 2,
  EditFile = 3,
  SubmitFiles = 4,
  ViewFile = 5,
  Finish = 6
}

export enum DocumentAddError {
  NoError,
  FileSizeError,
  MaxFilesError,
  TotalSizeError,
  FileNotAllowedError
}
